export default "/images/images/logo.png";